import { Injectable, Inject } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Ship } from '../../../Models/ship';
import { Mark } from '../models/mark';
import { OpenStreetMapService } from './open-street-map.service';
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Order } from '../../../Models/order';
import { Address } from '../../../Models/address';
import { DistanceService } from './distance.service';
import { VehicleShips } from '../../../dtos/vehicle-ships';

declare var H: any;

@Injectable()
export class ApiHereService {
  plataform: any;
  config: any = {
    "app_id": "IHKxBuDqxqSqOfLBkWyx",
    "app_code": "kdi7iIPFVMO8nTMHmE5SAA"
  }
  constructor(private http: HttpClient, private openStreetMapService: OpenStreetMapService, private distanceService: DistanceService) {

  }
  getMarksFromShips(ships: Ship[]): Observable<any> {
    let marks: Mark[] = [];
    let obs: any[] = [];
    if (ships && ships.length) {
      ships.forEach((item, index) => {
        if (!item.destination.latitude || !item.destination.longitude) {
          const observable = this.openStreetMapService.getCordenadasByAddress(item.destination);
          const observableMap = observable.pipe(map((result: any) => {
            item.destination.latitude = result[0].lat;
            item.destination.longitude = result[0].lon;
            return {
              id: item.id,
              lat: result[0].lat,
              lng: result[0].lon,
              data: item
            };
          }));
          obs.push(observableMap);
        } else {
          const observable = of({
            id: item.id,
            lat: item.destination.latitude,
            lng: item.destination.longitude,
            data: item
          });
          obs.push(observable);
        }
      });
    }
    return forkJoin(obs);
  }

  getLatLong(vehicle: VehicleShips) {
    let obs: any[] = [];
    vehicle.orders.forEach(item => {
      if (!item.shipment.destination.latitude || item.shipment.destination.longitude) {
        const observable = this.openStreetMapService.getCordenadasByAddress(item.shipment.destination);
        const observableMap = observable.pipe(map((result: any) => {
          if (result && result.length > 0) {
            item.shipment.destination.latitude = result[0].lat;
            item.shipment.destination.longitude = result[0].lon;
          }
          return item;
        }));
        obs.push(observableMap);
      }
    });
    return forkJoin(obs);
  }

  getShipSequence(shipsParam: Ship[], startParam: Address): Order[] {
    let ships = Object.assign([], shipsParam);
    let start = Object.assign([], startParam);
      let orderShip: Order[] = [];

    while (ships.length) {
      let minDistance: number | undefined = undefined;
      let minShip: Ship | undefined = undefined;
      let index: number = 0;
      for (let i = 0; i < ships.length; i++) {
        let distance = this.distanceService.getDistance([start.latitude, start.longitude], [ships[i].destination.latitude, ships[i].destination.longitude], { unit: 'meters' });
        if (minDistance == undefined) {
          minDistance = distance;
          minShip = ships[i];
        } else {
          if (distance < minDistance) {
            minDistance = distance;
            minShip = ships[i];
            index = i;
          }
        }
      }
      orderShip.push({
        nOrder: orderShip.length + 1,
        shipment: minShip
      });
      ships.splice(index, 1);
      start = Object.assign([], minShip.destination);
    }
    return orderShip;
  }

  getShipSequenceByOrder(ordersParam: Order[], startParam: Address): Order[] {
    let orders: Order[] = Object.assign([], ordersParam);
    let start = Object.assign([], startParam);
      let orderShip: Order[] = [];

    while (orders.length) {
      let minDistance: number | undefined = undefined;
      let minShip: Order | undefined = undefined;
      let index: number = 0;
      for (let i = 0; i < orders.length; i++) {
        let distance = this.distanceService.getDistance([start.latitude, start.longitude], [orders[i].shipment.destination.latitude, orders[i].shipment.destination.longitude], { unit: 'meters' });
        if (minDistance == undefined) {
          minDistance = distance;
          minShip = orders[i];
        } else {
          if (distance < minDistance) {
            minDistance = distance;
            minShip = orders[i];
            index = i;
          }
        }
      }
      orderShip.push({
        id : minShip.id,
        nOrder: orderShip.length + 1,
        shipment: minShip.shipment
      });
      orders.splice(index, 1);
      start = Object.assign([], minShip.shipment.destination);
    }
    return orderShip;
  }

  paintRoute(marks: any[], start: Mark, end: Mark, onResult) {
    let router = this.getPlataform().getRoutingService();
    let routingParams:any = {
      'mode': 'fastest;car',
      'waypoint0': 'geo!' + start.lat + ',' + start.lng,
      'representation': 'display'
    };
    if (marks && marks.length) {
      marks.forEach((item, i) => {
        routingParams['waypoint' + (i + 1)] = 'geo!' + (item.lat ? item.lat : item.getPosition().lat) + ',' + (item.lng ? item.lng : item.getPosition().lng);
      });
    }
    if (end) {
      routingParams['waypoint' + ((!marks || !marks.length) ? 1 : (marks.length + 1))] = 'geo!' + end.lat + ',' + end.lng;
    }
    router.calculateRoute(
      routingParams,
      onResult,
      function (error) {
        alert(error.message);
      }
    );
    
  }

  getPlataform() {
    if (!this.plataform) {
      this.plataform = new H.service.Platform(this.config);
    }
    return this.plataform;
  }

  getFindSequenceService(): FindSequenceService {
    return {
      findSequence: (parameters: any, success: any, error: any): any => {
        let params = new HttpParams();
        params = params.append('app_id', this.config.app_id);
        params = params.append('app_code', this.config.app_code);
        params = params.append('start', parameters.start);
        parameters.destinations.forEach((item, i) => {
          params = params.append('destination' + (i + 1), item);
        });
        params = params.append('end', parameters.end);
        params = params.append('mode', parameters.mode);
        this.http.get('https://wse.api.here.com/2/findsequence.json', { params: params }).subscribe(success, error);
      }
    };
  }
}
export interface FindSequenceService {
  findSequence(parameters: any, success: any, error: any): any;
}
